export default __webpack_public_path__ + "static/media/shop-left.c5bbc82f.png";